( function () {
    'use strict';
    /**
     * This provides global variables
     *
     * @namespace
     */
    master.settings = {
        /**
         * Returns how long forms should be preserved in secs
         * @type {integer}
         */
        formPreservableTimeout: 60, //sec
        /**
         * Returns global animation speed
         * @type {integer}
         */
        animateSpeed: 300,
        /**
         * Returns animationEnd variables
         * @type {string}
         */
        animationEnd: 'webkitAnimationEnd oanimationEnd oAnimationEnd animationend',
        /**
         * Returns transitionEnd variables
         * @type {string}
         */
        transitionEnd: 'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
        /**
         * Enable/disabled debugging
         * @type {boolean}
         */
        debug: false,
        /**
         * @namespace
         * @type {object}
         */
        administration: {
            /**
             * Returns the max interval for a service-item in minutes

             * @type {integer}
             */
            minServiceIntervals: 15,
            /**
             * Returns the min interval for a service-item in minutes

             * @type {integer}
             */
            maxServiceIntervals: 300
        },
        /**
         * @namespace

         * @type {object}
         */
        booking: {
            /**
             * Returns gap between timeslots

             * @type {integer}
             */
            timeslotGap: 15,
            /**
             * Returns the modifier for calculation with timeslots

             * @type {integer}
             */
            timeslotModifier: 1,
            /**
             * Returns standard date format

             * @type {string}
             */
            dateFormat: 'DD-MM-YYYY',
            /**
             * Returns timeout for service calculator

             * @type {integer}
             */
            calculatorTimeout: 10000
        },
        /**
         * @namespace

         * @type {object}
         */
        licenseplate: {
            /**
             * Returns licensplate length

             * @type {integer}
             */
            length: 7
        },
        /**
         * @namespace
         * @type {object}
         */
        workshopSearch: {
            /**
             * Returns max items to show in workshop search

             * @type {integer}
             */
            maxItems: 6,
            /**
             * Returns min length of typed chars in workshop search before firing

             * @type {integer}
             */
            minLength: 3
        },
        /**
         * @namespace
         * @type {object}
         */
        maps: {
            /**
             * Returns Google maps API-key

             * @type {string}
             */
            testKey: 'AIzaSyA3LRccxkm4Wzf6SYUuR1Tbw1qT0O67ye4',
            apiKey: 'AIzaSyA3LRccxkm4Wzf6SYUuR1Tbw1qT0O67ye4',
            geolocation: true,
            syncListWithMap: true,
            results: {
                min: 2,
                sensitivity: 0.5,
                zoom: {
                    min: 12,
                    max: 15
                }
            },
            country: {
                DK: {
                    center: {
                        lat: 56.26392,
                        lng: 9.501785
                    },
                    zoom: 7
                }
            },
            /**
             * Returns maps icons

             * @type {object}
             */
            icons: {
                markers: {
                    standard: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker.png',
                    webshopBooking: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-webshop-booking.png',
                    webshop: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-webshop.png',
                    booking: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-booking.png',
                    selected: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/map-marker-selected.png'
                },
                cluster: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
                cluster_v2: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/markerclusterer/m'

            },
            /**
             * Returns Google maps initial zoom level

             * @type {integer}
             */
            zoom: 7,
            /**
             * Returns if Google maps controls show be visible

             * @type {boolean}
             */
            controls: false,
            /**
             * Returns Google maps style

             * @type {object}
             */
            clusterStyles:[{
                url: '/Files/Templates/Designs/ftz-master/assets/img/rasterized-graphics/markerclusterer/m1.png',
                textColor:'#000',
                height: 53,
                width: 53
            }],
            styles: [ {
                featureType: 'administrative.land_parcel',
                elementType: 'all',
                stylers: [ {
                    visibility: 'off'
                } ]
            }, {
                featureType: 'landscape.man_made',
                elementType: 'all',
                stylers: [ {
                    visibility: 'off'
                } ]
            }, {
                featureType: 'poi',
                elementType: 'labels',
                stylers: [ {
                    visibility: 'off'
                } ]
            }, {
                featureType: 'road',
                elementType: 'labels',
                stylers: [ {
                    visibility: 'simplified'
                }, {
                    lightness: 20
                } ]
            }, {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [ {
                    hue: '#f49935'
                } ]
            }, {
                featureType: 'road.highway',
                elementType: 'labels',
                stylers: [ {
                    visibility: 'simplified'
                } ]
            }, {
                featureType: 'road.arterial',
                elementType: 'geometry',
                stylers: [ {
                    hue: '#fad959'
                } ]
            }, {
                featureType: 'road.arterial',
                elementType: 'labels',
                stylers: [ {
                    visibility: 'off'
                } ]
            }, {
                featureType: 'road.local',
                elementType: 'geometry',
                stylers: [ {
                    visibility: 'simplified'
                } ]
            }, {
                featureType: 'road.local',
                elementType: 'labels',
                stylers: [ {
                    visibility: 'simplified'
                } ]
            }, {
                featureType: 'transit',
                elementType: 'all',
                stylers: [ {
                    visibility: 'off'
                } ]
            }, {
                featureType: 'water',
                elementType: 'all',
                stylers: [ {
                    color: '#acbcc9'
                }, {
                    saturation: 30
                }, {
                    lightness: 49
                } ]
            } ]
        },
        /**
         * @namespace
         * @type {object}
         */
        brand: {
            /**
             * Returns global brand identifier

             * @type {string}
             */
            prefix: 'ftz-master',
            /**
          * Returns global brand Facebook access token
 
          * @type {string}
          */
            facebookAccessToken: '468040784586034|mF5_xHqpYF6BW4dLBSo6nFJHSG8',
            /**
             * Returns global brand Facebook app ID

             * @type {string}
             */
            facebookAppID: '468040784586034'
        }
    };
    /**
     * @namespace
     */
    master.data = {
        /**
         * ajax settings for workshop async calls
         */
        workshops: {
            endpoint: '/services/workshop.ashx',
            actions: {
                lookup: 'lookupworkshop',
                set: 'setworkshop',
                get: 'getcurrentworkshop',
                clear: 'clearworkshop'
            }
        },
        /**
         * ajax settings for service calculator async calls
         */
        serviceCalculator: {
            endpoint: '/services/ServiceCalculator.ashx',
            actions: {
                getserviceinfo: 'getserviceinfo'
            }
        },
        /**
         * ajax settings for service calendar async calls
         */
        serviceCalendar: {
            endpoint: '/services/ServiceCalendar.ashx',
            actions: {
                getvehicle: 'getvehicledetail',
                delete: 'deletetempapp',
                getday: 'getday',
                getmonth: 'getmonth'
            }
        },
        /**
         * ajax settings for orders async calls
         */
        orderHandler: {
            endpoint: '/services/OrderHandler.ashx',
            actions: {
                getstockdetail: 'getstockdetail',
                removeservicelines: 'removeservicelines',
                removeproductlines: 'removeproductlines',
                checkusername: 'checkusername'
            }
        }
    };
    /**
     * @namespace
     */
    master.store = {
        /**
         * set / get localstorage
         */
        local: {
            set: function ( key, value ) {
                localStorage.setItem( key, value );
            },
            unset: function ( key ) {
                localStorage.removeItem( key );
            },
            myViewState: localStorage.getItem( 'myViewState' ),
            zipcodes: localStorage.getItem( 'master-zipcodes' ),
            serviceCalculatorUrl: localStorage.getItem( 'calc-service-url' )
        },
        /**
         * set / get sessionstorage
         */
        session: {
            set: function ( key, value ) {
                sessionStorage.setItem( key, value );
            },
            unset: function ( key ) {
                sessionStorage.removeItem( key );
            },
            myLicenseplate: sessionStorage.getItem( 'myLicenseplate' ),
            myCar: sessionStorage.getItem( 'myCar' ),
            myWorkshop: sessionStorage.getItem( 'myWorkshop' ),
            userManagementAddresses: sessionStorage.getItem( 'UserManagementAddresses' ),
            myAlternateLicenseplate: sessionStorage.getItem( 'myAlternateLicenseplate' ),
            svgRepo: JSON.parse( sessionStorage.getItem( 'svg-repo' ) ) || {},
            serviceDatetime: sessionStorage.getItem( 'service-datetime' ),
            serviceAdded: sessionStorage.getItem( 'calc-service-added' ),
            workshopReturnUrl: sessionStorage.getItem( 'workshop-return-url' ),
            returnCache: sessionStorage.getItem( 'return-cache' ),
            userAddons: sessionStorage.getItem( 'user-addons' ),
            backlink: sessionStorage.getItem( 'productlist-history' )
        }
    };
    /**
     * @namespace
     */
    master.translations = {
        /**
         * Translations from DW
         */
        base: jQuery( '.js-translations' )
    };
    /**
     * @namespace
     */
    master.scripts = {
        /**
         * Get vendor scripts
         */
        vendor: {
            timeout: 2000,
            get: function ( vendor, type ) {
                if ( master.scripts.vendor[ vendor ][ type ] !== undefined ) {
                    return master.scripts.vendor[ vendor ][ type ];
                }
            },
            moment: {
                js: '/Files/System/master/cdn/js/moment.js',
                url: '/Files/System/master/cdn/js/moment.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/moment.js/2.17.1/moment-with-locales.min.js',
                css: null,
                callback: null
            },
            jqueryUI: {
                js: '/Files/System/master/cdn/js/jquery-ui.js',
                url: '/Files/System/master/cdn/js/jquery-ui.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js',
                css: '/Files/System/master/cdn/css/jquery-ui.css',
                callback: null
            },
            calendar: {
                js: '/Files/System/master/cdn/js/fullcalendar.js',
                url: '/Files/System/master/cdn/js/fullcalendar.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/fullcalendar/3.4.0/fullcalendar.min.js',
                css: '/Files/System/master/cdn/css/fullcalendar.css',
                callback: null
                
            },
            calendarLocal: {
                js: '/Files/System/master/cdn/js/fullcalendar-da.js',
                url: '/Files/System/master/cdn/js/fullcalendar-da.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/fullcalendar/3.4.0/locale/da.js',
                css: null,
                callback: null
            },
            tinymce: {
                js: '//cdnjs.cloudflare.com/ajax/libs/tinymce/4.5.7/tinymce.min.js',
                url: '//cdnjs.cloudflare.com/ajax/libs/tinymce/4.5.7/tinymce.min.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/tinymce/4.5.7/tinymce.min.js',
                css: null,
                callback: null
            },
            handlebars: {
                js: '/Files/System/master/cdn/js/handlebars.js',
                url: '/Files/System/master/cdn/js/handlebars.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/handlebars.js/4.0.11/handlebars.min.js',
                css: null,
                callback: null
            },
            MarkerClusterer: {
                js: '/Files/System/master/cdn/js/markerclusterer.js',
                url: '/Files/System/master/cdn/js/markerclusterer.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer_compiled.js',
                css: null,
                callback: null
            },
            jQueryUImap: {
                js: '/Files/System/master/cdn/js/jquery-ui-map.js',
                url: '/Files/System/master/cdn/js/jquery-ui-map.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/jquery-ui-map/3.0-rc1/min/jquery.ui.map.min.js',
                css: null,
                callback: null
            },
            typeahead: {
                js: '/Files/System/master/cdn/js/typeahead.js',
                url: '/Files/System/master/cdn/js/typeahead.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/corejs-typeahead/1.1.1/typeahead.jquery.min.js',
                css: null,
                callback: null
            }
        },
        /**
         * Local files
         */
        files: {
            administration: {
                file: '_administration.js',
                namespace: 'administration'
            },
            maps: {
                file: '_maps.js',
                namespace: 'maps'
            },
            dealersearch_v2: {
                file: '_dealersearch-v2.js',
                namespace: 'dealersearch_v2'
            }
        },
        /**
         * get local files
         */
        require: function ( file ) {
            if ( master.scripts.files[ file ] !== undefined ) {
                window.master[ master.scripts.files[ file ].namespace ] = {};
                jQuery.getScript( 'Files/System/master/design/js/' + master.scripts.files[ file ].file ).done( function () {
                    window.master[ master.scripts.files[ file ].namespace ].init();
                } );
            }
        },
        init: function () {
            if ( jQuery( '[data-require-script="administration"]' ).length ) {
                master.scripts.require( 'administration' );
            }
            if ( jQuery( '[data-require-script="maps"]' ).length ) {
                master.scripts.require( 'maps' );
            }
            if ( jQuery( '[data-require-script="dealersearch_v2"]' ).length ) {
                master.scripts.require( 'dealersearch_v2' );
            }
        }
    };
}() );
